import { createStorage } from '@aviata/storage';

import type { bloomreachEventsConfig } from '@/shared/lib';

import type { EventsState } from './types';

const BLOOMREACH_EVENTS_STATE_KEY = 'free-avia:bloomreach-events-state';

export const useBloomreachEventsState = () => {
  const storage = createStorage(sessionStorage);
  const state: EventsState = storage.parse(BLOOMREACH_EVENTS_STATE_KEY) ?? {};

  const updateState = ({
    event,
    properties,
  }: {
    event: bloomreachEventsConfig.BloomreachEventName;
    properties: Record<string, unknown>;
  }) => {
    state[event] = { ...properties };
    storage.stringify(BLOOMREACH_EVENTS_STATE_KEY, state);
  };

  const resetState = () => {
    storage.remove(BLOOMREACH_EVENTS_STATE_KEY);
    Object.keys(state).forEach(key => delete state[key]);
  };

  return {
    state,
    updateState,
    resetState,
  };
};
